/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Jobs_EmptyInputs */

const en_jobs_empty = /** @type {(inputs: Jobs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No jobs found.`)
};

const he_jobs_empty = /** @type {(inputs: Jobs_EmptyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`לא נמצאו משימות.`)
};

/**
* | output |
* | --- |
* | "No jobs found." |
*
* @param {Jobs_EmptyInputs} inputs
* @param {{ locale?: "en" | "he" }} options
* @returns {LocalizedString}
*/
export const jobs_empty = /** @type {((inputs?: Jobs_EmptyInputs, options?: { locale?: "en" | "he" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Jobs_EmptyInputs, { locale?: "en" | "he" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_jobs_empty(inputs)
	return he_jobs_empty(inputs)
});